"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitLogBase = void 0;
const Entities_1 = require("../../Entities");
class SubmitLogBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (castPayload.sender === undefined || castPayload.severity === undefined || castPayload.message === undefined) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = 'SUBMIT_LOG';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const { sender, message, severity } = this.castPayloadV1(payload);
                this.action(sender, severity, message);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.SubmitLogBase = SubmitLogBase;
